export const getDealTypeKey = (
  id: string,
  dealTypes: { id: string; name: string; key: string }[],
) => {
  return dealTypes.find((type) => type.id === id)?.key;
};
